import React from 'react';
import { Box, Typography } from '@mui/material';
import { useFeatureTheme } from '../../../../../theme/hooks/useFeatureTheme';

export default function FieldSettingsPanel({ title, children, sx }) {
  const { semantic, radiusPx } = useFeatureTheme();

  return (
    <Box
      sx={{
        p: { xs: 1.25, sm: 1.5 },
        borderRadius: radiusPx.md,
        border: `1px solid ${semantic.borders.border}`,
        bgcolor: semantic.surfaces.surfaceSubtle ?? semantic.surfaces.background,
        ...sx,
      }}
    >
      {title ? (
        <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
          {title}
        </Typography>
      ) : null}
      {children}
    </Box>
  );
}
